export const EMAIL_REG_EXP =
  /[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/;
export const PHONE_REG_EXP = /\+7\s\d{3}\s\d{3}\s\d{2}\s\d{2}/;
